import React from "react"
// import configureStore from "./src/store/configureStore"
// import configureReadPlanStore from "./src/store/useReadPlan/configureReadPlanStore"
import "./static/global.css"
import WrapLayout from "./src/components/Layout/WrapLayout"
import initGA from './src/apis/googleAnalytics'

const isBrowser = typeof window !== "undefined"

const setupLocalStorage = () => {
  if (!localStorage.getItem("currentLanguage")) {
    localStorage.setItem("currentLanguage", "ENG")
  }
  if (!localStorage.getItem("currentVersion")) {
    localStorage.setItem("currentVersion", "NLT")
  }
  if (!localStorage.getItem("currentSegment")) {
    localStorage.setItem("currentSegment", "S001")
  }
}

export const wrapPageElement = ({ element, props }) => {
  return <WrapLayout {...props}>{element}</WrapLayout>
}
export const wrapRootElement = ({ element, props }) => {
  if (isBrowser) {
    setupLocalStorage()
  }
  return <div {...props}>{element}</div>
}

export function registerServiceWorker() {
  return true
}
